module.exports = __webpack_public_path__ + "static/img/alclad-aluminum-sheet_256.d06e49d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alclad-aluminum-sheet_256.png
// module id = 759m
// module chunks = 0